// _actionTypes.js

export const UPDATE_VIDEO_PROGRESS = 'UPDATE_VIDEO_PROGRESS';
export const COMPLETE_VIDEO = 'COMPLETE_VIDEO';

// Fetch Available Courses
export const FETCH_AVAILABLE_COURSES_REQUEST = 'FETCH_AVAILABLE_COURSES_REQUEST';
export const FETCH_AVAILABLE_COURSES_SUCCESS = 'FETCH_AVAILABLE_COURSES_SUCCESS';
export const FETCH_AVAILABLE_COURSES_FAILURE = 'FETCH_AVAILABLE_COURSES_FAILURE';

// Fetch enrolled courses
export const FETCH_ENROLLED_COURSES_REQUEST = 'FETCH_ENROLLED_COURSES_REQUEST';
export const FETCH_ENROLLED_COURSES_SUCCESS = 'FETCH_ENROLLED_COURSES_SUCCESS';
export const FETCH_ENROLLED_COURSES_FAILURE = 'FETCH_ENROLLED_COURSES_FAILURE';

// Enroll Course
export const ENROLL_COURSE_REQUEST = 'ENROLL_COURSE_REQUEST';
export const ENROLL_COURSE_SUCCESS = 'ENROLL_COURSE_SUCCESS';
export const ENROLL_COURSE_FAILURE = 'ENROLL_COURSE_FAILURE';

// Unenroll Course
export const UNENROLL_COURSE_REQUEST = 'UNENROLL_COURSE_REQUEST';
export const UNENROLL_COURSE_SUCCESS = 'UNENROLL_COURSE_SUCCESS';
export const UNENROLL_COURSE_FAILURE = 'UNENROLL_COURSE_FAILURE';

// Clear Messages
export const CLEAR_ENROLLMENT_MESSAGE = 'CLEAR_ENROLLMENT_MESSAGE';
export const CLEAR_COURSE_CONTENT = 'CLEAR_COURSE_CONTENT';

// Student Course Contents
export const FETCH_STUDENT_COURSE_CONTENTS_REQUEST = 'FETCH_STUDENT_COURSE_CONTENTS_REQUEST';
export const FETCH_STUDENT_COURSE_CONTENTS_SUCCESS = 'FETCH_STUDENT_COURSE_CONTENTS_SUCCESS';
export const FETCH_STUDENT_COURSE_CONTENTS_FAILURE = 'FETCH_STUDENT_COURSE_CONTENTS_FAILURE';

// Student Content Stats
export const FETCH_STUDENT_CONTENT_STATS_REQUEST = 'FETCH_STUDENT_CONTENT_STATS_REQUEST';
export const FETCH_STUDENT_CONTENT_STATS_SUCCESS = 'FETCH_STUDENT_CONTENT_STATS_SUCCESS';
export const FETCH_STUDENT_CONTENT_STATS_FAILURE = 'FETCH_STUDENT_CONTENT_STATS_FAILURE';

// Student Content By ID
export const FETCH_STUDENT_CONTENT_BY_ID_REQUEST = 'FETCH_STUDENT_CONTENT_BY_ID_REQUEST';
export const FETCH_STUDENT_CONTENT_BY_ID_SUCCESS = 'FETCH_STUDENT_CONTENT_BY_ID_SUCCESS';
export const FETCH_STUDENT_CONTENT_BY_ID_FAILURE = 'FETCH_STUDENT_CONTENT_BY_ID_FAILURE';

// Student Update Content Progress
export const UPDATE_STUDENT_CONTENT_PROGRESS_REQUEST = 'UPDATE_STUDENT_CONTENT_PROGRESS_REQUEST';
export const UPDATE_STUDENT_CONTENT_PROGRESS_SUCCESS = 'UPDATE_STUDENT_CONTENT_PROGRESS_SUCCESS';
export const UPDATE_STUDENT_CONTENT_PROGRESS_FAILURE = 'UPDATE_STUDENT_CONTENT_PROGRESS_FAILURE';

// Student Mark Content Complete
export const MARK_STUDENT_CONTENT_COMPLETE_REQUEST = 'MARK_STUDENT_CONTENT_COMPLETE_REQUEST';
export const MARK_STUDENT_CONTENT_COMPLETE_SUCCESS = 'MARK_STUDENT_CONTENT_COMPLETE_SUCCESS';
export const MARK_STUDENT_CONTENT_COMPLETE_FAILURE = 'MARK_STUDENT_CONTENT_COMPLETE_FAILURE';

// Student Fetch Next Content
export const FETCH_STUDENT_NEXT_CONTENT_REQUEST = 'FETCH_STUDENT_NEXT_CONTENT_REQUEST';
export const FETCH_STUDENT_NEXT_CONTENT_SUCCESS = 'FETCH_STUDENT_NEXT_CONTENT_SUCCESS';
export const FETCH_STUDENT_NEXT_CONTENT_FAILURE = 'FETCH_STUDENT_NEXT_CONTENT_FAILURE';